import { Dialog, DialogType, getTheme, Stack } from 'office-ui-fabric-react';
import React, { useState, useEffect } from 'react';
import { SemanticIcon, SemanticIconName, SemanticIconSize } from '../Icons';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export let ToastType = /*#__PURE__*/function (ToastType) {
  ToastType["Info"] = "Info";
  ToastType["Warning"] = "Warning";
  ToastType["Success"] = "Success";
  return ToastType;
}({});
export const Toast = props => {
  const [isVisible, setIsVisible] = useState(false);
  useEffect(() => {
    setIsVisible(props.isOpen);
    if (!props.isOpen) return;
    const timer = setTimeout(() => {
      setIsVisible(false);
      props.onClose && props.onClose();
    }, props.visibilityTime);
    return () => clearTimeout(timer);
  }, [props.isOpen, props.visibilityTime, props.onClose]);
  const closeToast = () => {
    setIsVisible(false);
    props.onClose && props.onClose();
  };
  const getIconColor = () => {
    switch (props.type) {
      case ToastType.Info:
        return getTheme().palette.yellowDark;
      case ToastType.Success:
        return getTheme().palette.greenDark;
      case ToastType.Warning:
        return getTheme().palette.red;
    }
  };
  const getIconType = () => {
    switch (props.type) {
      case ToastType.Info:
        return SemanticIconName.Info;
      case ToastType.Success:
        return SemanticIconName.Yes;
      case ToastType.Warning:
        return SemanticIconName.Alert;
    }
  };
  const renderIcon = () => /*#__PURE__*/_jsx(Stack, {
    styles: {
      root: {
        color: getIconColor()
      }
    },
    children: /*#__PURE__*/_jsx(SemanticIcon, {
      semanticName: getIconType(),
      size: SemanticIconSize.Medium
    })
  });
  const renderTitleText = () => /*#__PURE__*/_jsx(Stack, {
    "data-id": "".concat(props.dataId, "-title"),
    children: props.title
  });
  const rendersubText = () => /*#__PURE__*/_jsx(Stack, {
    as: "span",
    "data-id": "".concat(props.dataId, "-description"),
    children: props.subText
  });
  const renderTitleWithIcon = () => /*#__PURE__*/_jsxs(Stack, {
    horizontal: true,
    verticalAlign: "center",
    tokens: {
      childrenGap: 5
    },
    children: [renderIcon(), renderTitleText()]
  });
  return /*#__PURE__*/_jsx(Dialog, {
    hidden: !isVisible,
    onDismiss: () => closeToast(),
    minWidth: 500,
    dialogContentProps: {
      type: DialogType.close,
      title: renderTitleWithIcon(),
      subText: rendersubText(),
      styles: {
        title: {
          paddingBottom: 7
        },
        subText: {
          marginBottom: 0
        },
        content: {
          minHeight: 92
        }
      }
    },
    modalProps: {
      isBlocking: false,
      isModeless: true,
      styles: {
        root: {
          alignItems: 'start',
          justifyContent: 'end'
        },
        main: {
          marginRight: 80,
          marginTop: 60,
          position: 'fixed'
        }
      }
    },
    styles: {
      main: {
        minHeight: 92
      }
    }
  });
};